export const SearchData =[
    {
        id:1,
        name:'About us',
        title:'About us',
        desc:'Connecting Millions… Where They Live, Work and Travel! Nation’s fastest growing IP-1 provider of end-to-end digital Connectivity Infrastructure Solutions focusing on In-Building Solutions (IBS) and',
        url:'/about-us'
    },
    {
        id:2,
        name:'Sustainability',
        title:'Sustainability',
        desc:'Our Sustainability Initiatives Towards a Sustainable Digital Infrastructure Solution We strive to operate in an inclusive environment where we can support the communities we serve,',
        url:'/sustainability'
    },
    {
        id:3,
        name:'Privacy Policy',
        title:'Privacy Policy',
        desc:'Crest Digitel Privacy Policy Crest Digitel Private Limited and all other related affiliates and subsidiaries (collectively “Crest Digitel”, “we” or “us”) value your privacy. We',
        url:'/privacy-policy'
    },
    {
        id:4,
        name:'Our Values',
        title:'Our Values',
        desc:'Our Guiding Principles Our Vision “Enabling Connections for Life” Our Mission “Be a Leading Digital Connectivity Infrastructure partner” admired and preferred by all our stakeholders.',
        url:'/our-values'
    },
    {
        id:5,
        name:'Our Initiatives CSR',
        title:'Our Initiatives',
        desc:'Our Impact Stories Our Impact Stories At Crest Digitel, we believe that doing business responsibly and sustainably is crucial for building long-term growth and stakeholder',
        url:'/our-initiatives'
    },
    {
        id:6,
        name:'Our Operations ',
        title:'Our Operations',
        desc:'Providing excellent service in Network Infrastructure What We Do As one of the leading Passive-Digital Connectivity Infrastructure Providers (DCIP) in the country, we assist all',
        url:'/our-operations'
    },
    {
        id:7,
        name:'Our Partners',
        title:'Our Partners',
        desc:'Our Partners A ‘Win – Win’ Model for Realtors, Occupants and Operators. Our Customers Operators Our Customers Public, Corporate and Retail',
        url:'/our-partners'
    },
    {
        id:8,
        name:'Life At Crest',
        title:'Life At Crest',
        desc:'Life at Crest Enabled Workforce Our culture is built on the pillars of Care, Connect and Collaboration and is supported by a solid value system',
        url:'/life-at-crest'
    },
    {
        id:9,
        name:'Leadership ',
        title:'Leadership',
        desc:'Our Leadership Team Board of Directors Mihir Nerurkar MD & COO India Brookfield Infrastructure Group Ritu Singh Senior Vice President – HR Brookfield Asset Management',
        url:'/leadership'
    },
    {
        id:10,
        name:'Get In Touch',
        title:'Get In Touch',
        desc:'Contact us Crest Digitel Private Limited(Formerly Space Teleinfra Private Limited) Registered & Corporate Office: Plot No. 278, Ground Floor, A – Square Building, Udyog Vihar,',
        url:'/get-in-touch'
    },
    {
        id:11,
        name:'',
        title:'Home',
        desc:'WHO WE ARE Interconnecting infrastructure seamlessly Crest Digitel is a leading Indian Digital Connectivity Infrastructure company backed by global parentage that is committed to providing',
        url:'/'
    },
    {
        id:12,
        name:'Our Portfolio',
        title:'Our Portfolio',
        desc:'An overview of our portfolio As the leading Passive-Digital Connectivity Infrastructure Provider, we offer a wide range of services for commercial, residential, and industrial customers.',
        url:'/our-portfolio'
    },
    {
        id:13,
        name:'Careers',
        title:'Careers',
        desc:'Join a team where we create delight through connected experiences Would you be interested in joining us on a journey where one of the common',
        url:'/careers'
    },
    {
        id:14,
        name:'Contact',
        title:'Contact',
        desc:'Contact us Crest Digitel Private Limited(Formerly Space Teleinfra Private Limited) Registered & Corporate Office: Plot No. 278, Ground Floor, A – Square Building, Udyog Vihar,',
        url:'/get-in-touch'
    },
   
    {
        id:15,
        name:'Annualreport CDPL AGM',
        title:'Announcements',
        desc:'Announcements Annual Report Notice of 11th AGM of CDPL',
        url:'/announcement'
    },
    {
        id:16,
        name:'Awards Recognitions',
        title:'Awards & Recognitions',
        desc:'Awards and Recognitions Great Place to Work Our culture at Crest is rooted in the pillars of Care, Connect, and Collaborate and is powered by',
        url:'/awards-and-recognitions'
    },
    {
        id:17,
        name:'Our Marquee Deployments',
        title:'Our Marquee Deployments',
        desc:'Our Marquee Deployments Metros & Airports Presence in leading metros and airports across the country Delhi Metro Chennai Metro Lucknow Metro Mumbai Metro Kolkata Metro',
        url:'/our-marquee-deployment'
    },
    {
        id:18,
        name:'Codes and Policies',
        title:'Codes and Policies',
        desc:'Codes and Policies Health, Safety, Security & Environment Policy We at Crest Digitel believe that the Occupational Health, Safety, and Security of human beings overrides',
        url:'/codes-policies'
    },
    {
        id:19,
        name:'Media Kit',
        title:'Media Kit',
        desc:'Media Kit Brand Guidelines Crest Digitel Logo Boiler Plate',
        url:'/codes-policies'
    },
    {
        id:20,
        name:'Newsroom',
        title:'Newsroom',
        desc:'In the news Brookfield buys ?Space Teleinfra for over Rs 900 crore in cash-cum-units deal Know More Brookfield-led Tower Infrastructure to acquire Space Teleinfra for',
        url:'/newsroom'
    },
    
]